import React from 'react';

import { FaqDomainViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Input } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { FaqDomainFieldProps, FaqDomainFormValues } from '../../types';

function InputName({
  values,
  validateField,
}: FaqDomainFieldProps): React.ReactElement {
  const key: keyof FaqDomainFormValues = 'name';

  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Domaine',
          rules: [
            {
              required: true,
              validator: async (_rule, value): Promise<void> => {
                return await validateField(
                  key,
                  FaqDomainViolationDtoFormFieldEnum.NAME,
                  value,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputName;
